import {object, string} from "yup";
import {FIELDS} from "./constants";

const React = require('react');
const {PAYMENT_METHODS_LIST} = require('../../../../constants/paymentMethods/');

const {FormWrapper, FormFooter} = require('../../FormHandlers');
const {AdminStaticTableWithScroll} = require('../AdminStaticTable');

const FeeInput = require('./components/FeeInput');
const fieldsCtor = require('./utils/fieldsCtor');

import openPopupUpdate from "./utils/openPopupUpdate";
import openPopupGlobalReset from "./utils/openPopupGlobalReset";

module.exports = ({minWidth, maxHeight, items = [], additionalColsCtor, onSubmit, onResult, onGlobalClick, disabledGlobal}) => {
  const formData = {};
  const paymentTypesNames = {};

  const schema = {};

  PAYMENT_METHODS_LIST.forEach((method) => {
    const id = method.id;
    const row = items.find((el) => method.id === el.payment_method) || {};
    FIELDS.forEach((key) => {
      const rowKey = `${id}_${key}`;
      formData[rowKey] = row[key] || '0';
      schema[rowKey] = string().positiveNumber().integer().required();
    });
  })


  fieldsCtor(items, (id, row, key) => {
    const rowKey = `${id}_${key}`;
    formData[rowKey] = row[key] || '0';
    schema[rowKey] = string().positiveNumber().integer().required();
  });

  const paymentTypesIds = PAYMENT_METHODS_LIST.map(({id, name}) => {
    paymentTypesNames[id] = name;
    return {payment_method: id}
  });

  const getMethodFiatCode = (payment_method) => {
    return ['upi', 'upiQrCode', 'netbanking'].includes(payment_method) ? '$' : '€';
  }

  return (
    <>
      {/*<AdminSubtitle text="onramp" />*/}
      <FormWrapper
        data={formData}
        schema={{default: object(schema)}}
        onSubmit={(res) => {
          const payload = {}

          Object.keys(res).forEach((rawKey) => {
            const [id, ...rest] = rawKey.split('_');
            const key = rest.join('_');

            if (!payload[id]) payload[id] = {};

            payload[id][key] = res[rawKey];
          });

          if (onSubmit) {
            return new Promise((onResult) => {
              openPopupUpdate({payload, onSubmit, onResult});
            });
          }
        }}
        onResult={onResult}
      >{(formCtx) => (
          <div>
            <AdminStaticTableWithScroll
              minWidth={minWidth}
              maxHeight={maxHeight}
              items={paymentTypesIds}
              cols={[
                {
                  title: 'Payment Method',
                  className: 'w125 fx1 p0-i',
                  handleCol: ({payment_method}) => <b>{paymentTypesNames[payment_method] || payment_method}</b>,
                },
                {
                  title: 'Transaction Fee',
                  className: 'w125 pv0-i ph11-i',
                  handleCol: ({payment_method}) => (
                    <FeeInput
                      name={`${payment_method}_transaction_fee`}
                      formCtx={formCtx}
                      symbol="%"
                    />
                  ),
                },
                {
                  title: 'Exchange Spread',
                  className: 'w125 pv0-i ph11-i',
                  handleCol: ({payment_method}) => (
                    <FeeInput
                      name={`${payment_method}_exchange_spread`}
                      formCtx={formCtx}
                      symbol="%"
                    />
                  ),
                },
                {
                  title: <span>Exchange Spread<br/>(stable coin)</span>,
                  className: 'w125 pv0-i ph11-i',
                  handleCol: ({payment_method}) => (
                    <FeeInput
                      name={`${payment_method}_exchange_spread_sc`}
                      formCtx={formCtx}
                      symbol="%"
                    />
                  ),
                },
                {
                  title: <span>Minimum<br/>transaction fee</span>,
                  className: 'w125 pv0-i ph11-i',
                  handleCol: ({payment_method}) => (
                    <FeeInput
                      name={`${payment_method}_min_tx_fee`}
                      formCtx={formCtx}
                      symbol={getMethodFiatCode(payment_method)}
                    />
                  ),
                },
                {
                  title: <span>Referral<br/>partner fee</span>,
                  className: 'w125 pv0-i ph11-i',
                  handleCol: ({payment_method}) => (
                    <FeeInput
                      name={`${payment_method}_referral_fee`}
                      formCtx={formCtx}
                      symbol="%"
                    />
                  ),
                },
                {
                  title: <span>Fixed fee<br/>Lunu</span>,
                  className: 'w125 pv0-i ph11-i',
                  handleCol: ({payment_method}) => (
                    <FeeInput
                      name={`${payment_method}_fixed_fee_lunu`}
                      formCtx={formCtx}
                      symbol={getMethodFiatCode(payment_method)}
                    />
                  ),
                },
                {
                  title: <span>Fixed fee<br/>Partner</span>,
                  className: 'w125 pv0-i ph11-i',
                  handleCol: ({payment_method}) => (
                    <FeeInput
                      name={`${payment_method}_fixed_fee_referral`}
                      formCtx={formCtx}
                      symbol={getMethodFiatCode(payment_method)}
                    />
                  ),
                },
                ...(additionalColsCtor ? additionalColsCtor(formCtx) : [])
              ]}
            />
            <FormFooter
              className="mb25"
              submitBtnData={{
                text: 'Save configuration',
                formCtx
              }}
              additionalBtnsList={
                onGlobalClick
                  ? [{
                    text: 'Reset to Global',
                    onClick: () => openPopupGlobalReset(onGlobalClick),
                    disabled: disabledGlobal
                  }]
                  : []
              }
            />
          </div>
        )
      }</FormWrapper>
    </>
  );
};
